import {objectToCamelCase, objectToSnakeCase} from '../utils'
import api from './api'
import options from './options'
import SurveyQuestion from '@/services/surveyQuestions'

export default class Survey {
  static api = api.create(Survey)
  static options = options
  static readOnlyFields = ['id', 'surveyId']
  constructor(survey) {
    const {id = '', name = '', surveyId = '', questions = []} = survey
    Object.assign(this, {
      id,
      name,
      surveyId,
      questions: questions ? questions.map(SurveyQuestion.fromAPI) : null,
    })
  }

  static create(opts) {
    return new Survey(opts)
  }

  static fromAPI(json) {
    return new Survey(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(survey, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = survey[field]
      })
    } else {
      data = survey
    }

    //
    excludeFields = [...Survey.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof Survey)) {
      throw Error(`${name} must be an instance of the Survey class.`)
    }
  }
}
